import React, { Component } from "react";

class NotificationCard extends Component {
  render() {
    const { date, message } = this.props;
    var date1 = date.split("-");
    return (
      <div className="shadow-sm border p-3 rounded">
        <div className="th-12 th-medium">
          {date1[2] + "-" + date1[1] + "-" + date1[0]}
        </div>
        <div className="th-12 th-grey">{message}</div>
      </div>
    );
  }
}
export default NotificationCard;
